import { createFileRoute, redirect } from '@tanstack/react-router';

import { isPersonExecutive } from 'helpers/person';

export const Route = createFileRoute('/_private/_route')({
  beforeLoad: async ({ context }) => {
    // Team onboarding /signup expects a team role; executives have no roles.
    if (isPersonExecutive(context.user)) {
      return;
    }

    // @ts-ignore
    const metadata = window.Clerk?.user?.publicMetadata || {};

    if (
      'onboarding_complete' in metadata &&
      metadata.onboarding_complete === false
    ) {
      throw redirect({ replace: true, to: '/signup' });
    }
  },
});
